const s = (e, t) => t.some((n) => new RegExp(`^${n.replace(/\*/g, ".*")}$`).test(e)), i = (e = "", t) => t.includes(e), o = (e, t) => {
  const n = `.${e.name.split(".").pop()}`, r = e.type;
  return i(n, t) || s(r, t);
};
export {
  i as validateFileExtension,
  o as validateFileFormat,
  s as validateFileTypes
};
//# sourceMappingURL=index.es840.js.map
